<template>
    <div>
        <v-chip
            v-for="chip in chipsToDisplay"
            :key="field ? chip[field] : chip"
            size="small"
            class="pt-0 mt-0 mr-1"
        >
            {{ field ? chip[field] : chip }}
        </v-chip>
        <v-tooltip v-if="hiddenItems.length" z-index="200" bottom>
            <template v-slot:activator="{ props: activatorProps }">
                <v-chip v-bind="activatorProps" size="small">
                    {{ $t('general.labels.plusXMore', { count: hiddenItems.length }) }}
                </v-chip>
            </template>
            <ul class="simple-list">
                <li
                    v-for="(item, hiddenIndex) in hiddenItems"
                    :key="'h-item' + hiddenIndex"
                    class="simple-list__item"
                >
                    <span>
                        {{ field ? item[field] : item }}
                    </span>
                </li>
            </ul>
        </v-tooltip>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { drop, slice } from 'lodash';

const props = defineProps({
    items: {
        type: Array,
        required: true,
    },
    field: {
        type: String,
        required: false,
    },
    maxNumChipsToDisplay: {
        type: Number,
        required: false,
        default: 2,
    },
});

const chipsToDisplay = computed(() => {
    if (props.items.length > props.maxNumChipsToDisplay) {
        return slice(props.items, 0, props.maxNumChipsToDisplay);
    }
    return props.items;
});
const hiddenItems = computed(() => {
    if (props.items.length > props.maxNumChipsToDisplay) {
        return drop(props.items, props.maxNumChipsToDisplay);
    }
    return [];
});
</script>

<style lang="scss" scoped>
.simple-list {
    list-style-type: none;
    padding: 0;

    &__item {
        span {
            &:not(:last-child):after {
                content: '\2014'; // em dash
                margin: 0 0.3rem;
            }
        }
    }
}
</style>
